// Prev/next controls for horizontal scroll-snap strips on the Permanent Jewelry page.
// Markup: <pj-slider [data-loop] [data-step="page"]> ... [data-pj-track] ... [data-pj-prev] [data-pj-next] </pj-slider>
if (!customElements.get('pj-slider')) {
  customElements.define(
    'pj-slider',
    class PjSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-pj-track]');
        if (!this.track) return;
        this.querySelectorAll('[data-pj-prev], [data-pj-next]').forEach((button) => {
          button.addEventListener('click', () => this.go(button.hasAttribute('data-pj-next') ? 1 : -1));
        });
      }

      go(direction) {
        const track = this.track;
        const width = track.clientWidth;
        const max = track.scrollWidth - width;
        const current = track.scrollLeft;
        const step = this.dataset.step === 'page' ? width : Math.round(width * 0.6);
        let target = current + direction * step;

        if (this.hasAttribute('data-loop')) {
          if (direction > 0 && current >= max - 5) target = 0;
          if (direction < 0 && current <= 5) target = max;
        }

        track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }
  );
}
